import { defineComponent as n, computed as p, openBlock as c, createBlock as r, unref as s } from "vue";
import a from "../assets/icons/last-page.svg.mjs";
const u = /* @__PURE__ */ n({
  __name: "last-page-icon",
  props: {
    fill: { default: "currentColor" },
    size: { default: "md" }
  },
  setup(e) {
    const l = e, o = {
      sm: "12px",
      md: "16px",
      lg: "24px",
      xl: "32px",
      "2xl": "48px"
    }, t = p(() => o[l.size]);
    return (i, d) => (c(), r(s(a), {
      fill: i.fill,
      width: t.value,
      style: {
        verticalAlign: "middle",
        display: "inline-block",
        height: "auto"
      }
    }, null, 8, ["fill", "width"]));
  }
});
export {
  u as default
};
//# sourceMappingURL=last-page-icon.vue.mjs.map
